module.exports = __webpack_public_path__ + "img/visipointlogo@2x.0c45d782.png";